import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnMarketingBtnComponent } from './dn-marketing-btn.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [DnMarketingBtnComponent],
  imports: [CommonModule, MatButtonModule],
  exports: [DnMarketingBtnComponent],
})
export class DnMarktingBtnModule {}
